import { Reveal } from "@/lib/motion";
import { useSiteContent } from "@/lib/useSiteContent";

export default function InvestmentPhilosophy() {
  const c = useSiteContent().philosophy;
  return (
    <section id="philosophy" data-testid="philosophy-section" className="section-pad bg-[#FAFAF8]">
      <div className="max-w-[1400px] mx-auto px-6 md:px-10">
        <div className="md:max-w-3xl">
          <Reveal><p className="eyebrow">{c.eyebrow}</p></Reveal>
          <Reveal delay={0.05}>
            <h2 className="font-serif-luxe text-[#1D1D1F] text-4xl md:text-5xl leading-[1.08] mt-5">
              {c.heading}
            </h2>
          </Reveal>
          {c.intro && (
            <Reveal delay={0.1}>
              <p className="text-[#616161] leading-relaxed mt-6 max-w-2xl">{c.intro}</p>
            </Reveal>
          )}
        </div>

        <div className="mt-16 grid md:grid-cols-2 gap-x-16 gap-y-4">
          {(c.steps || []).map((s, i) => (
            <Reveal key={i} delay={i * 0.05}>
              <div
                data-testid={`philosophy-step-${i}`}
                className="grid grid-cols-[80px_1fr] gap-6 items-start py-8 border-b border-black/10"
              >
                <div className="gold-numeral">{String(i + 1).padStart(2, "0")}</div>
                <div>
                  <h3 className="font-serif-luxe text-2xl md:text-3xl text-[#1D1D1F]">{s.title}</h3>
                  <p className="text-[#616161] text-sm md:text-base leading-relaxed mt-3">{s.body}</p>
                </div>
              </div>
            </Reveal>
          ))}
        </div>

        {c.closing_statement && (
          <Reveal delay={0.15}>
            <p className="font-serif-luxe italic text-2xl md:text-3xl text-[#1D1D1F] mt-16 max-w-3xl leading-snug">
              {c.closing_statement}
            </p>
          </Reveal>
        )}
      </div>
    </section>
  );
}
